import { SettingMessages, TranslationSettingMessages } from "../interfaces/settingMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationSettingMessages = {
  [SettingMessages.settingTitlePage]: "Settings",
  [SettingMessages.settingDeleteOptionTitle]: "Delete account",
  [SettingMessages.settingChangePasswordOptionTitle]: "Change password",
  [SettingMessages.settingLoginVerificationFailed]: `Failed to verify password, check your current password and
    try again`,
  [SettingMessages.settingParamsTitle]: "Parameters",
  [SettingMessages.settingColorsTitle]: "Colors",
  [SettingMessages.settingIconsTitle]: "Icons",
  [SettingMessages.settingParamsMinDaysDescription]: "Minimum days to request programming",
  [SettingMessages.settingParamsDaysLabel]: "Days",
  [SettingMessages.settingColorsPrimary]: "Primary color",
  [SettingMessages.settingColorsSecondary]: "Secondary color",
  [SettingMessages.settingColorsTertiary]: "Tertiary color",
  [SettingMessages.settingsColorsDisable]: "Inactivity color",
  [SettingMessages.settingsColorsLoginBackground]: "Login background color",
  [SettingMessages.settingEnvironmentTitle]: "Environment",
  [SettingMessages.settingParamsSuccessUpdate]: "Parameters updated successfully.",
  [SettingMessages.settingParamsNoChange]: "No parameter has changed.",
  [SettingMessages.settingNotificationReload]: "When changing the appearance, the page will reload for updating.",
  [SettingMessages.settingColorsNoChange]: "No color has changed.",
  [SettingMessages.settingIconsNoChange]: "No icon has changed."
};
